import baseData from './liuliang'
const mixin = {
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    formatData () {
      const choiceDate = JSON.parse(sessionStorage.getItem('toggleDate')).time
      // 选中的年
      const choiceYear = choiceDate.split('-')[0]
      // 选中的月
      const choiceMonth = choiceDate.split('-')[1]
      var startDate = new Date(choiceDate)
      // 获取当前月份第一天是周几
      let day =
        parseInt(startDate.getDay()) === 0 ? 7 : parseInt(startDate.getDay())
      this.firstMouthDay = day
      // 判断当月有几周
      let days = new Date(choiceYear, choiceMonth, 0).getDate() // 获取当月总共天数
      this.currentMouthDays = days
      for (let i = 0; i < days; i++) {
        baseData.list.push({
          'id': i + Math.random(),
          'actualValue': 0,
          'gap': 0,
          'activits': [],
          'totalWeekAll': '',
          'totalActualWeek': 0
        })
      }
      let y = days % 7
      var zhou = 0
      if (7 - day >= y) {
        zhou = parseInt(days / 7) + 1
      } else {
        zhou = parseInt(days / 7) + 2
      }
      let endDate = new Date(choiceDate + `-` + days).getDay()
      if (endDate === 0) {
        zhou = zhou - 1
      }
      this.mouthWeeks = zhou
      this.currentChoiceDate = choiceDate
      // 计算出当前月总共几周 每周的开始时间结束时间
      let arr = []
      for (let i = 0; i < zhou; i++) {
        if (i === 0) {
          arr.push({
            start: choiceDate + '-' + Number(i + 1),
            startI: Number(i + 1),
            end: choiceDate + '-' + (7 - day + 1 + 7 * i),
            endI: 7 - day + 1 + 7 * i
          })
        } else {
          arr.push({
            start: choiceDate + '-' + (7 - day + 1 + 7 * i + 1 - 7),
            startI: 7 - day + 1 + 7 * i + 1 - 7,
            end:
              choiceDate +
              '-' +
              (7 - day + 1 + 7 * i > days ? days : 7 - day + 1 + 7 * i),
            endI: 7 - day + 1 + 7 * i > days ? days : 7 - day + 1 + 7 * i
          })
        }
      }
      this.mouthWeeksDays = arr
    },
    setNewData (data, week, activity, type) {
      const temp = JSON.parse(JSON.stringify(data))
      let warr = []
      for (let i in this.mouthWeeksDays) {
        let arr = temp.slice(
          this.mouthWeeksDays[i].startI - 1,
          this.mouthWeeksDays[i].endI
        )
        let total = 0
        let averageTotal = 0
        for (let n in arr) {
          arr[n].totalWeekAll = (Number(week[i])).toFixed(2) // 全部周目标值
          arr[n].totalWeekNormal = (Number(week[i])).toFixed(2) // 日常期周目标值
          arr[n].totalWeekActivity = 0 // 节点期周目标值
          arr[n].activityTotal = 0
          arr[n].gap = (
            Number(week[i]) -
            Number(arr[n].actualValue)
          ).toFixed(2)
          total += Number(arr[n].actualValue)
          // 竞争力看板计算周实际值 计算方式为 本周日均值相加除以本周天数
          // TODO 考虑当前这周没有过完，应该是当前几天相加除以当前天数
          averageTotal = (total / arr.length).toFixed(2)
        }
        warr.push(averageTotal)
        for (let m in arr) {
          if (type === 'payrate' || type === 'retention_one' || type === 'retention_seven') {
            arr[m].totalActualWeek = Number(warr[i]) ? (Number(warr[i]).toFixed(2) + '%') : 0// 周实际值
          } else {
            arr[m].totalActualWeek = Number(warr[i]).toFixed(2) // 周实际值
          }
        }
      }

      for (let x in activity) {
        let num = 0
        for (let m in temp) {
          if (m >= Number(activity[x].sday) && m <= Number(activity[x].eday)) {
            num += Number(temp[m].actualValue)
            temp[m].activits.push(activity[x])
            // TODO activity[x].lengthDay  活动的天数 gap = 活动目标值 除以 活动天数  减去  日实际值
            temp[m].gap = (Number(activity[x].nodeTargetValue) - Number(temp[m].actualValue)).toFixed(2)
            temp[m].totalWeekAll = (Number(activity[x].nodeTargetValue)).toFixed(2)
            temp[m].totalWeekNormal = 0
            temp[m].totalWeekActivity = (Number(activity[x].nodeTargetValue)).toFixed(2)
          }
        }

        for (let m in temp) {
          if (m >= Number(activity[x].sday) && m <= Number(activity[x].eday)) {
            temp[m].activityTotal += Number(temp[m].actualValue) // 活动期实际值总和
          } else {
            temp[m].activityTotal = 0
          }
        }
      }
      // console.log('组装之后数据：', temp)
      return temp
      // this.allDataYS.list = temp
    },
    getLeftData () {
      return [
        { title: '月目标值', value: ' ' },
        { title: '月实际值', value: ' ' },
        { title: '月GAP值', value: ' ' }
      ]
    },
    getSelectOptions () {
      return [
        {
          name: '营收金额',
          value: 'revenue',
          id: 'revenue'
        },
        {
          name: '付费用户数',
          value: 'pagusernum',
          id: 'pagusernum'
        },
        {
          name: '付费arpu值',
          value: 'payarpunum',
          id: 'payarpunum'
        }
      ]
    },
    getSelectOptionsP () {
      return [
        {
          name: '付费转化率',
          value: 'payrate',
          id: 'payrate'
        },
        {
          name: '活跃用户留存率(次日)',
          value: 'retention_one',
          id: 'retention_one'
        },
        {
          name: '活跃用户留存率(七日)',
          value: 'retention_seven',
          id: 'retention_seven'
        }
      ]
    },
    getSelectOptionsL () {
      return [
        {
          name: '曝光(uv)',
          value: 'exposure_uv',
          id: 'exposure_uv'
        },
        {
          name: '曝光(pv)',
          value: 'exposure_pv',
          id: 'exposure_pv'
        },
        {
          name: '点击',
          value: 'clicked',
          id: 'clicked'
        },
        {
          name: '起播(启动)',
          value: 'play',
          id: 'play'
        }
      ]
    }
  }
}
export default mixin
